import React from 'react';
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import {NotificationManager, NotificationContainer} from "react-notifications";
import TableComponent from "../common/TableComponent";
import {AddCircleOutlineTwoTone, AddCircleTwoTone, SystemUpdateAltTwoTone} from "@material-ui/icons";

import TextField from "@material-ui/core/TextField";
import {KeyboardDatePicker, KeyboardTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import {BlueButton, GreenButton, OrangeButton, RedButton} from "../common/ButtonsConstants";
import { t } from '../../i18n';
import {
    addManagementReviewRevision,
    deleteManagementReview,
    managementReview, managementReviewDefaultAgendaItems,
    managementReviewRevision,
    saveOrUpdateManagementReview
} from "../../util/OperationModuleApiUtils";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Modal from "@material-ui/core/Modal";
import CommonRevisionModal from "../common/CommonRevisionModal";
import Typography from "@material-ui/core/Typography";
import {Spinner} from "../common/Spinner";
import {exportReport} from "../../util/ApiUtils";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import * as CommonUtils from "../../util/CommonUtils";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

const columns = [
    { name: t('management.columns.identifier'), id: 'identifier', type: "text" },
    { name: t('management.columns.date'), id: 'displayDate', type: "text" },
    { name: t('management.columns.time'), id: 'displayTime', type: "text" },
    { name: t('management.columns.location'), id: 'meetingLocation', type: "text" },
    { name: t('management.columns.attendees'), id: 'attendees', type: "text" },
    { name: t('management.columns.apologies'), id: 'apologies', type: "text" },
];

class ManagementReviewMeeting extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            managementReviews: [],
            managementReviewDefaultAgendaItems: [],
            agendaItems: [],
            latestRevision: {},
            isLoading: true,
            isEditing: false,
            show: false,
            date: null,
            showTime: null,
            identifier: "",
            meetingLocation: "",
            apologies: "",
            attendees: "",
        };
        this.loadManagementReview = this.loadManagementReview.bind(this);
        this.loadManagementReviewDefaultAgendaItems = this.loadManagementReviewDefaultAgendaItems.bind(this);
        this.loadManagementReviewRevision = this.loadManagementReviewRevision.bind(this);
        this.handleAddRow = this.handleAddRow.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.onTimeChange = this.onTimeChange.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleAgendaItemResponseChange = this.handleAgendaItemResponseChange.bind(this);
        this.handleAgendaItemDescriptionChange = this.handleAgendaItemDescriptionChange.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.addRevision = this.addRevision.bind(this);
        this.onAddAgendaItem = this.onAddAgendaItem.bind(this);
        this.onAddAgendaItemObjective = this.onAddAgendaItemObjective.bind(this);
        this.onAgendaItemRemoved = this.onAgendaItemRemoved.bind(this);
        this.onAgendaItemObjectiveRemoved = this.onAgendaItemObjectiveRemoved.bind(this);
        this.handleAgendaItemTargetMet = this.handleAgendaItemTargetMet.bind(this);
        this.handleAgendaItemTarget = this.handleAgendaItemTarget.bind(this);
        this.handleAgendaItemComments = this.handleAgendaItemComments.bind(this);
        this.handleAgendaItemObjective = this.handleAgendaItemObjective.bind(this);
    }

    showModal() {
        this.setState({
            show: true
        });
    }

    closeModal(updatedRevision) {
        console.log("updatedRevision");
        console.log(updatedRevision);
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    componentDidMount() {
        this.loadManagementReviewDefaultAgendaItems();
        this.loadManagementReview();
        this.loadManagementReviewRevision();
    }

    addRevision(request) {
        addManagementReviewRevision(request)
            .then(response => {
                NotificationManager.success(t('app.notifications.success'), t('messages.revisionUpdated'), 5000);
                console.log('response');
                console.log(response);
                this.closeModal(response);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    loadManagementReviewRevision() {
        managementReviewRevision()
            .then(response => {
                console.log(response);
                this.setState({
                    latestRevision: response,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    loadManagementReview() {
        managementReview()
            .then(response => {
                console.log('review', response);
                this.setState({
                    managementReviews: response,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    loadManagementReviewDefaultAgendaItems() {
        managementReviewDefaultAgendaItems()
            .then(response => {
                console.log('agendaItems', response);
                this.setState({
                    managementReviewDefaultAgendaItems: response,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    onEdit(managementReview) {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: false,
            id: managementReview.id,
            date: managementReview.date,
            header: `${managementReview.identifier}`,
            meetingLocation: managementReview.meetingLocation,
            apologies: managementReview.apologies,
            attendees: managementReview.attendees,
            agendaItems: managementReview.agendaItems,
        });
        if (managementReview.time) {
            this.setState({
                showTime: moment(managementReview.time, "HH:mm"),
                submitTime: managementReview.time,
            });
        }
    }

    onAddAgendaItem() {
        const maxNumber = (Math.max.apply(Math, this.state.agendaItems.map(function(o) { return o.number; })) + 1).toFixed(1);
        this.setState({
            agendaItems: this.state.agendaItems.concat({
                immutable: false,
                number: maxNumber,
                type: 'SIMPLE'
            })
        });
    }

    onAddAgendaItemObjective(index) {
        console.log('inspecting index', index)
        if (this.state.agendaItems[index] && this.state.agendaItems[index].objectiveTargets) {
            let agendaItems = this.state.agendaItems;
            agendaItems[index].objectiveTargets = agendaItems[index].objectiveTargets.concat({
                objective: "",
                target: "",
                comments: "",
                targetMet: false
            });
            this.setState({
                agendaItems
            });
        }
    }

    handleAddRow() {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: true,
            date: null,
            showTime: null,
            identifier: "",
            meetingLocation: "",
            agendaItems: this.state.managementReviewDefaultAgendaItems,
            apologies: "",
            attendees: "",
            header: t('management.newRecord'),
        })
    }

    reset() {
        this.setState({
            isEditing: false,
            isLoading: true,
            isNew: true,
            date: null,
            showTime: null,
            identifier: "",
            meetingLocation: "",
            agendaItems: this.state.managementReviewDefaultAgendaItems,
            apologies: "",
            attendees: "",
            header: t('management.newRecord'),
        });
        this.loadManagementReview();
    }

    onCancel() {
        this.reset();
    }

    onDelete(record) {
        console.log(record);
        deleteManagementReview(record)
            .then(() => {
                console.log("removed id " + record.id);
                console.log("removed " + record);
                console.log(this.state);
                NotificationManager.success(t('app.notifications.success'), t('messages.managementReviewRemoved'), 5000);
                this.reset();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    onSave(event) {
        event.preventDefault();
        saveOrUpdateManagementReview(this.state)
        .then(() => {
            NotificationManager.success(t('app.notifications.success'), t('messages.managementReviewUpdated'), 5000);
            this.reset();
        }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    handleTextChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    handleAgendaItemDescriptionChange({ target }) {
        this.setState({
            agendaItems: this.state.agendaItems.map(
                (item) => `${item.number}_description` === target.name ? {...item, description: target.value}
                    : item
            )
        });
    }

    handleAgendaItemResponseChange({ target }) {
        this.setState({
            agendaItems: this.state.agendaItems.map(
                (item) => `${item.number}_response` === target.name ? {...item, response: target.value}
                    : item
            )
        });
    }

    handleAgendaItemObjective(index, index2, target) {
        let agendaItems = this.state.agendaItems;
        agendaItems[index].objectiveTargets[index2].objective = target.value;
        this.setState({
            agendaItems
        });
    }

    handleAgendaItemTarget(index, index2, target) {
        let agendaItems = this.state.agendaItems;
        agendaItems[index].objectiveTargets[index2].target = target.value;
        this.setState({
            agendaItems
        });
    }

    handleAgendaItemComments(index, index2, target) {
        let agendaItems = this.state.agendaItems;
        agendaItems[index].objectiveTargets[index2].comments = target.value;
        this.setState({
            agendaItems
        });
    }

    handleAgendaItemTargetMet(index, index2, target) {
        let agendaItems = this.state.agendaItems;
        agendaItems[index].objectiveTargets[index2].targetMet = target.value;
        this.setState({
            agendaItems
        });
    }

    onAgendaItemRemoved(number) {
        this.setState({
            agendaItems: this.state.agendaItems
                .filter(function(item) {
                    return item.number !== number
                })
        });
    }

    onAgendaItemObjectiveRemoved(index, index2) {
        console.log('index', index);
        console.log('index2', index2);
        if (this.state.agendaItems[index] && this.state.agendaItems[index].objectiveTargets) {
            console.log('this.state.agendaItems[index]', this.state.agendaItems[index]);
            console.log('this.state.agendaItems[index].objectiveTargets', this.state.agendaItems[index].objectiveTargets);
            let agendaItems = this.state.agendaItems;
            agendaItems[index].objectiveTargets = agendaItems[index].objectiveTargets.filter(function (item, indexInState) {
                    return indexInState !== index2
                });
            this.setState({
                agendaItems
            });
        }
    }

    onTimeChange(event, time) {
        this.setState({
            ...this.state, submitTime: time.toString(),
        });

        this.setState({
            ...this.state, showTime: moment(time, "HH:mm"),
        });
    }

    onDateChange(event, date) {
        console.log(event); //null
        console.log('date', date); //whatever the date the user picked
        this.setState({
            ...this.state, date: moment(date, "DD/MM/YYYY"),
        });
    }

    render() {
        let { state } = this;
        let { classes } = this.props;
        if (state.isLoading) {
            return <Spinner/>;
        }

        const isRevision = (state.latestRevision.id !== null);
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return (
            <div>
                <Typography component="h2" variant="h5">
                    { t('management.title') }
                </Typography>
                <Paper className={classes.root} style={{ marginTop: '30px' }}>
                    <Card className={classes.card}>
                        {(!state.isEditing ? (
                            <CardHeader
                                action={
                                    <BlueButton
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<AddCircleOutlineTwoTone/>}
                                        onClick={this.showModal}
                                        size="small"
                                        style={{marginRight: '10px'}}
                                        disabled={isAuditor || isViewer}
                                    >
                                        { t('common.add') }
                                    </BlueButton>
                                }
                                title={
                                    <span style={{color: "darkblue"}}>
                                        <p><b>{isRevision && `${t('context.common.revision')} ${state.latestRevision.number} ${t('context.common.author')}: ${state.latestRevision.author}`}</b></p>
                                        <p><b>{ t('context.common.approvedFor') }: {state.latestRevision.approvedBy} {t('context.common.on')} {moment(state.latestRevision.date).format('DD/MM/YYYY')}</b></p>
                                    </span>
                                }
                            />
                        ) : (
                            <CardHeader
                                style={{ paddingBottom: "0px", paddingLeft: "46px" }}
                                title={<span style={{color: "darkblue"}}><p><b>{state.header}</b></p></span>}
                            />
                        ))}
                        <CardContent>
                            {(!state.isEditing ? (
                                <div>
                                    {!isDemo && !isViewer && (
                                        <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={() => exportReport('/management-review/export')} style={{ float: 'right', marginRight: "160px" }}>
                                            { t('common.export') }
                                        </GreenButton>
                                    )}
                                    <TableComponent
                                        tableKey="managementReviewTable"
                                        data={state.managementReviews}
                                        columns={columns}
                                        handleSubmit={this.handleSubmit}
                                        handleAddRow={this.handleAddRow}
                                        handleRowDel={this.onDelete}
                                        handleRowEdit={this.onEdit}
                                        allowAdd={isRevision && !isAuditor && !isViewer ? 'show' : 'disable'}
                                        pagination={true}
                                        allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
                                    />
                                </div>
                            ) : (
                                <div style={{ paddingLeft: "30px", paddingRight: "30px",  paddingBottom: "30px"}}>
                                    <div>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                disableToolbar
                                                autoOk
                                                variant="inline"
                                                format="DD/MM/YYYY"
                                                margin="normal"
                                                id="date"
                                                label={ t('management.labels.date') }
                                                name="date"
                                                value={state.date}
                                                onChange={ this.onDateChange }
                                                KeyboardButtonProps={{ 'aria-label': 'change date' }}
                                                style={{ width: "300px"}}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardTimePicker
                                                margin="normal"
                                                id="time"
                                                label={ t('management.labels.time') }
                                                format="HH:mm"
                                                value={state.showTime}
                                                onChange={this.onTimeChange}
                                                KeyboardButtonProps={{ 'aria-label': 'change time' }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="meetingLocation"
                                            name="meetingLocation"
                                            value={state.meetingLocation}
                                            label={ t('management.labels.location') }
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="attendees"
                                            name="attendees"
                                            value={state.attendees}
                                            label={ t('management.labels.attendees') }
                                            multiline
                                            rows={3}
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="apologies"
                                            label={ t('management.labels.apologies') }
                                            name="apologies"
                                            value={state.apologies}
                                            onChange={this.handleTextChange}
                                            multiline
                                            rows={4}
                                            style={{ width: "800px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <Table className={classes.table} aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="left"><h2>{ t('management.agenda.title') }</h2></TableCell>
                                                    <TableCell align="left"></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {state.agendaItems.map((row, index) => (
                                                    <TableRow key={row.number}>
                                                        <TableCell component="th" scope="row" style={{ verticalAlign: 'top' }}>
                                                            { state.agendaItems[index].immutable === true ? (
                                                                <h3>{state.agendaItems[index].number} {state.agendaItems[index].description}</h3>
                                                            ) : (
                                                                <div>
                                                                    <h3>{state.agendaItems[index].number}</h3>
                                                                    <TextField
                                                                        name={state.agendaItems[index].number + "_description"}
                                                                        value={state.agendaItems[index].description}
                                                                        label={ t('management.agenda.description') }
                                                                        onChange={this.handleAgendaItemDescriptionChange}
                                                                        style={{width: "800px"}}
                                                                    />
                                                                </div>
                                                            )}

                                                            { state.agendaItems[index].type === 'SIMPLE' ? (
                                                                <TextField
                                                                    name={state.agendaItems[index].number + "_response"}
                                                                    value={state.agendaItems[index].response}
                                                                    onChange={this.handleAgendaItemResponseChange}
                                                                    label={ t('management.agenda.response') }
                                                                    multiline
                                                                    rows={4}
                                                                    style={{width: "800px"}}
                                                                />
                                                            ) : (
                                                                <div>
                                                                    <Table>
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell align="left">{ t('management.agenda.objective') }</TableCell>
                                                                                <TableCell align="left">{ t('management.agenda.target') }</TableCell>
                                                                                <TableCell align="left">{ t('management.agenda.targetMet') }</TableCell>
                                                                                <TableCell align="left">{ t('management.agenda.comments') }</TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {state.agendaItems[index].objectiveTargets && state.agendaItems[index].objectiveTargets.map((objectiveRow, index2) => (
                                                                                <TableRow key={index2}>
                                                                                    <TableCell align="left">
                                                                                        <TextField
                                                                                            name={`${index}_${index2}_objective`}
                                                                                            value={state.agendaItems[index].objectiveTargets[index2].objective}
                                                                                            onChange={(e) => this.handleAgendaItemObjective(index, index2, e.target)}
                                                                                            label={ t('management.agenda.objective') }
                                                                                            multiline
                                                                                            rows={4}
                                                                                            style={{width: "400px"}}
                                                                                        />
                                                                                    </TableCell>
                                                                                    <TableCell align="left">
                                                                                        <TextField
                                                                                            name={`${index}_${index2}_target`}
                                                                                            value={state.agendaItems[index].objectiveTargets[index2].target}
                                                                                            onChange={(e) => this.handleAgendaItemTarget(index, index2, e.target)}
                                                                                            label={ t('management.agenda.target') }
                                                                                            multiline
                                                                                            rows={4}
                                                                                            style={{width: "400px"}}
                                                                                        />
                                                                                    </TableCell>
                                                                                    <TableCell align="center">
                                                                                        <FormControl className={classes.formControl}>
                                                                                            <Select
                                                                                                labelId={`${index}_${index2}_targetMet-label`}
                                                                                                id={`${index}_${index2}_targetMet-id`}
                                                                                                value={state.agendaItems[index].objectiveTargets[index2].targetMet}
                                                                                                name={`${index}_${index2}_targetMet`}
                                                                                                onChange={(e) => this.handleAgendaItemTargetMet(index, index2, e.target)}
                                                                                            >
                                                                                                <MenuItem value={"true"}>{ t('common.yes') }</MenuItem>
                                                                                                <MenuItem value={"false"}>{ t('common.no') }</MenuItem>
                                                                                            </Select>
                                                                                        </FormControl>
                                                                                    </TableCell>
                                                                                    <TableCell align="left">
                                                                                        <TextField
                                                                                            name={`${index}_${index2}_comments`}
                                                                                            value={state.agendaItems[index].objectiveTargets[index2].comments}
                                                                                            onChange={(e) => this.handleAgendaItemComments(index, index2, e.target)}
                                                                                            label={ t('management.agenda.comments') }
                                                                                            multiline
                                                                                            rows={4}
                                                                                            style={{width: "400px"}}
                                                                                        />
                                                                                    </TableCell>
                                                                                    <TableCell>
                                                                                        <RedButton
                                                                                            variant="contained"
                                                                                            color="secondary"
                                                                                            startIcon={<AddCircleTwoTone />}
                                                                                            size="small"
                                                                                            onClick={() => this.onAgendaItemObjectiveRemoved(index, index2)}
                                                                                            style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                                                                                        >
                                                                                            { t('common.remove') }
                                                                                        </RedButton>
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            ))}
                                                                        </TableBody>
                                                                    </Table>
                                                                    <BlueButton
                                                                        variant="contained"
                                                                        color="secondary"
                                                                        startIcon={<AddCircleTwoTone />}
                                                                        size="small"
                                                                        onClick={() => this.onAddAgendaItemObjective(index)}
                                                                        style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                                                                    >
                                                                        { t('management.agenda.addObjective') }
                                                                    </BlueButton>
                                                                </div>
                                                            )}
                                                        </TableCell>
                                                        <TableCell>
                                                            { state.agendaItems[index].immutable !== true && (
                                                                <RedButton
                                                                    variant="contained"
                                                                    color="secondary"
                                                                    startIcon={<AddCircleTwoTone />}
                                                                    size="small"
                                                                    onClick={() => this.onAgendaItemRemoved(state.agendaItems[index].number)}
                                                                    style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                                                                >
                                                                    { t('common.remove') }
                                                                </RedButton>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <BlueButton
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<AddCircleTwoTone />}
                                            size="small"
                                            onClick={this.onAddAgendaItem}
                                            style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                                        >
                                            { t('management.agenda.addItem') }
                                        </BlueButton>
                                    </div>
                                    <div style={{ width: "800px", clear: "both", paddingTop: "30px" }}>
                                        <OrangeButton
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<AddCircleTwoTone />}
                                            size="small"
                                            onClick={this.onCancel}
                                            style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px' , float: "left" }}
                                        >
                                            { t('common.cancel') }
                                        </OrangeButton>
                                        <GreenButton
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<AddCircleTwoTone />}
                                            size="small"
                                            onClick={this.onSave}
                                            style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                                        >
                                            { t('common.save') }
                                        </GreenButton>
                                    </div>
                                </div>
                            ))}
                        </CardContent>
                    </Card>
                    <Modal
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        open={state.show}
                        onClose={() => this.closeModal(null)}
                    >
                        <CommonRevisionModal latestRevisionDto={state.latestRevision} addRevision={this.addRevision}/>
                    </Modal>
                </Paper>
                <NotificationContainer/>
            </div>
        );
    }
}

export default withStyles(classes)(ManagementReviewMeeting);
